/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */
import React, { FormEvent, ChangeEvent } from 'react';
import EmailIcon from '@material-ui/icons/Email';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { Box, Button, Typography, TextField, Snackbar } from '@material-ui/core';
import axios from 'axios';

function Alert(props: AlertProps) {
    return <MuiAlert elevation={0} variant="filled" {...props} />;
}

export const FeedbackForm = () => {
    const [successOpen, setSuccessOpen] = React.useState(false);
    const [errorOpen, setErrorOpen] = React.useState(false);

    const [email, setEmail] = React.useState("");
    const [message, setMessage] = React.useState("");

    const submitFeedback = (event: FormEvent) => {
        event.preventDefault();
        axios.post("https://formspree.io/xjvavpgw", {
            email: email,
            message: message
        }).then((response) => {
            setEmail("");
            setMessage("");
            setSuccessOpen(true);
        }).catch((error) => {
            setErrorOpen(true);
        });
    }

    const updateEmail = (event: ChangeEvent<HTMLInputElement>) => {
        setEmail(event.currentTarget.value);
    }

    const updateMessage = (event: ChangeEvent<HTMLInputElement>) => {
        setMessage(event.currentTarget.value);
    }

    const closeSuccess = () => {
        setSuccessOpen(false);
    }

    const closeError = () => {
        setErrorOpen(false);
    }

    return (
        <Box>
            <Typography variant="h6">Submit Feedback/Report a Bug</Typography>
            <p>If submitting a bug report, please include your device, browser, and any steps you can to reproduce!</p>
            <form onSubmit={submitFeedback} method="POST">
                <TextField margin="normal" variant="outlined" id="email" label="Email (Optional)" type="email" fullWidth onChange={updateEmail} />
                <TextField margin="normal" variant="outlined" id="message" label="Message" multiline required rows={4} fullWidth onChange={updateMessage} />
                <Button variant="contained" color="primary" type="submit" startIcon={<EmailIcon />}>
                    Send
                </Button>
            </form>
            <Snackbar open={successOpen} autoHideDuration={8000} onClose={closeSuccess}>
                <Alert onClose={closeSuccess} severity="success">
                    Feedback sent! Thanks!
                </Alert>
            </Snackbar>
            <Snackbar open={errorOpen} autoHideDuration={8000} onClose={closeError}>
                <Alert onClose={closeError} severity="error">
                    Error sending feedback. :(
                </Alert>
            </Snackbar>
        </Box>
    );
}